import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  overflow: hidden;
  background: ${({ theme }) => theme.palette.background.default};
`;

export const Content = styled.div`
  position: relative;
  z-index: 0;
  height: 100%;
  max-height: 100%;

  //overflow: auto;
`;

export const Header = styled.div<{ $isElectronMac: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 4.8rem;
  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(2)} ${theme.spacing(4)}`};

  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};

  color: ${({ theme }) => theme.palette.grey[400]};

  ${({ $isElectronMac }) =>
    $isElectronMac &&
    css`
      -webkit-app-region: drag;
    `}
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.h5)};
  color: ${({ theme }) => theme.palette.text.primary};
`;
